export const isComponentAllowed = (componentName) => {
  const accessiblePages = JSON.parse(localStorage.getItem("accessiblePages")) || [];
  return accessiblePages.length === 0 || accessiblePages.includes(componentName);
};
  
export const isCandidateComponent = (componentName) => {
  const accessiblePages = JSON.parse(localStorage.getItem("accessiblePages")) || [];
  return accessiblePages.includes(componentName);
};  
